<template>
  <div>
    <Dialog
      :header="$t('contacto.titulo.editarContacto')"
      :modal="true"
      :visible.sync="displayModal"
      :contentStyle="{ overflow: 'visible' }"
      @hide="closeDialog"
    >
      <Errors v-show="this.errors.length > 0" :errors="this.errors" />
      <div v-if="this.tipoContacto === 'email'">
        <div class="p-field">
          <label for="email"
            ><b>{{ $t("contacto.email.email") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-envelope"></i>
            </span>
            <InputText
              class="input"
              id="email"
              type="text"
              v-model="contacto.valor.email"
              :placeholder="$t('contacto.placeHolders.email.email')"
            />
          </div>
          <p
            class="text"
            v-tooltip.bottom="
              $t('contacto.notificaciones.tooltipCheckboxEmail')
            "
          >
            <Checkbox v-model="contacto.activo" :binary="true" />{{
              $t("contacto.notificaciones.checkboxEmail")
            }}
          </p>
        </div>
      </div>
      <Dialog
        :header="$t('contacto.email.activo.titulo')"
        :modal="true"
        :visible.sync="displayModificarEmailActivoModal"
        :contentStyle="{ overflow: 'visible' }"
        @hide="!displayModificarEmailActivoModal"
      >
        <div class="p-field">
          <Errors v-show="this.errors.length > 0" :errors="this.errors" />
          <p class="text">{{ $t("contacto.email.activo.descripcion") }}</p>
        </div>
        <template #footer>
          <div class="display-inline-flex">
            <Button
              @click.prevent="modificarEmailActivo(contacto)"
              :label="$t('common.buttons.confirm')"
              class=""
              icon="pi pi-save"
              iconPos="left"
            />
            <Button
              @click.prevent="
                errors.length == 0
                  ? modificaEmail(contacto)
                  : closeEditarEmailUsuarioDialog()
              "
              :label="$t('common.buttons.cancel')"
              class="p-button-secondary"
              icon="pi pi-times"
              iconPos="left"
            />
          </div>
        </template>
      </Dialog>

      <div v-if="this.tipoContacto === 'telefono'">
        <div class="p-field">
          <label for="telefono"
            ><b>{{ $t("contacto.telefono.telefono") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-mobile"></i>
            </span>
            <InputText
              class="input"
              id="telefono"
              type="text"
              v-model="contacto.valor.telefono"
              :placeholder="$t('contacto.placeHolders.telefono.telefono')"
            />
          </div>
          <p
            class="text"
            v-tooltip.bottom="
              $t('contacto.notificaciones.tooltipCheckboxPhone')
            "
          >
            <Checkbox v-model="contacto.activo" :binary="true" />{{
              $t("contacto.notificaciones.checkboxPhone")
            }}
          </p>
        </div>
      </div>

      <div v-if="this.tipoContacto === 'direccion'">
        <div class="p-grid p-fluid p-formgrid">
          <CTIAddress
            ref="ctiAddress"
            :required="true"
            @address:input="loadingCTIAddressNormalization = $event"
          />
          <div class="p-col-12 p-md-12 p-field">
            <p
              class="text"
              v-tooltip.bottom="
                $t('contacto.notificaciones.tooltipCheckboxAddress')
              "
            >
              <Checkbox v-model="contacto.activo" :binary="true" />{{
                $t("contacto.notificaciones.checkboxAddress")
              }}
            </p>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          @click.prevent="guardarContacto(contacto)"
          :label="$t('common.buttons.save')"
          class=""
          icon="pi pi-save"
          iconPos="left"
          :disabled="loadingCTIAddressNormalization"
        />
        <Button
          @click.prevent="closeDialog()"
          :label="$t('common.buttons.cancel')"
          class="p-button-secondary"
          icon="pi pi-times"
          iconPos="left"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Errors from "@/components/utilidades/Errors.vue";

import {
  MODIFICA_CONTACTO_EMAIL,
  MODIFICA_CONTACTO_TELEFONO,
  MODIFICA_CONTACTO_DIRECCION,
} from "@/graphQLQueries/ContactoQueries";
import { CAMBIAR_EMAIL_USUARIO } from "@/graphQLQueries/UsuarioQueries";
import CTIAddress from "@/components/portal-cliente/Utils/CTIAddress";

export default {
  name: "EditarContacto",
  props: ["id", "tipoContacto", "contacto", "displayDialog"],
  components: {
    Errors,
    CTIAddress,
  },
  data() {
    return {
      displayModal: this.displayDialog,
      dropdownTiposVia: [],
      dropdownPaises: [],
      dropdownProvincias: [],
      errors: [],
      selectedCountry: "ES",
      displayModificarEmailActivoModal: false,
      cambiarEmailActivoDelUsuario: undefined,
      loadingCTIAddressNormalization: false,
    };
  },
  created() {
    if (this.tipoContacto === "direccion") {
      this.contacto.valor.pais = "ES";
      this.contacto.valor.provincia = this.contacto.literalProvincia.clave;
    }
  },
  mounted() {
    if (this.tipoContacto === "direccion") {
      this.$refs.ctiAddress.setData({
        province: this.contacto.valor.provincia,
        location: this.contacto.valor.localidad,
        postalCode: this.contacto.valor.codigoPostal,
        typeOfRoad: this.contacto.valor.tipoDireccion,
        address: this.contacto.valor.direccion,
      });
    }
  },
  methods: {
    guardarContacto(contacto) {
      if (this.tipoContacto === "email") {
        if (contacto.activo) {
          this.displayModificarEmailActivoModal = true;
          return;
        }

        this.modificaEmail(contacto);
      } else if (this.tipoContacto === "telefono") {
        this.modificaTelefono(contacto);
      } else if (this.tipoContacto === "direccion") {
        this.modificaDireccion(contacto);
      }
    },

    createTelefonoRequest(contacto) {
      return {
        id: contacto.id,
        contactoTelefono: { telefono: contacto.valor.telefono },
        activo: contacto.activo,
      };
    },
    createEmailRequest(contacto) {
      return {
        id: contacto.id,
        contactoEmail: { email: contacto.valor.email },
        activo: contacto.activo,
      };
    },
    createDireccionRequest(contacto) {
      const ctiAddress = this.$refs.ctiAddress.getData();

      return {
        id: contacto.id,
        contactoDireccion: {
          tipoDireccion: ctiAddress.typeOfRoad,
          direccion: ctiAddress.address,
          codigoPostal: ctiAddress.postalCode,
          localidad: ctiAddress.location,
          provincia: ctiAddress.province,
          pais: "ES",
        },
        activo: contacto.activo,
      };
    },
    modificaTelefono(contacto) {
      this.$apollo
        .mutate({
          mutation: MODIFICA_CONTACTO_TELEFONO,
          variables: {
            id: contacto.idContacto,
            telefonoRequest: this.createTelefonoRequest(this.contacto),
          },
        })
        .then(() => {
          this.closeDialog();
        })
        .catch((exception) => {
          this.errors = [];
          exception.graphQLErrors.forEach((error) => {
            this.errors.push(this.$i18n.t("contacto.errores." + error.message));
          });
        });
    },
    modificaEmail(contacto) {
      this.$apollo
        .mutate({
          mutation: MODIFICA_CONTACTO_EMAIL,
          variables: {
            id: contacto.id,
            emailRequest: this.createEmailRequest(this.contacto),
          },
        })
        .then(() => {
          this.closeEditarEmailUsuarioDialog();
        })
        .catch((exception) => {
          this.errors = [];
          exception.graphQLErrors.forEach((error) => {
            this.errors.push(this.$i18n.t("contacto.errores." + error.message));
          });
        });
    },
    modificarEmailActivo(contacto) {
      this.$apollo
        .mutate({
          mutation: CAMBIAR_EMAIL_USUARIO,
          variables: {
            nuevoEmail: this.contacto.valor.email,
            idUsuario: this.id,
          },
        })
        .then(() => {
          this.modificaEmail(contacto);
          this.errors = [];
        })
        .catch((exception) => {
          console.log(exception);
          this.errors = [];
          exception.graphQLErrors.forEach((error) => {
            this.errors.push(this.$i18n.t("contacto.errores." + error.message));
          });
        });
    },
    modificaDireccion(contacto) {
      if (this.$refs.ctiAddress.valid()) {
        this.$apollo
          .mutate({
            mutation: MODIFICA_CONTACTO_DIRECCION,
            variables: {
              id: contacto.idContacto,
              direccionRequest: this.createDireccionRequest(this.contacto),
            },
          })
          .then(() => {
            this.closeDialog();
          })
          .catch((exception) => {
            this.errors = [];
            exception.graphQLErrors.forEach((error) => {
              this.errors.push(
                this.$i18n.t("contacto.errores." + error.message)
              );
            });
          });
      }
    },
    closeEditarEmailUsuarioDialog() {
      this.displayModificarEmailActivoModal = false;
      this.closeDialog();
    },
    closeDialog() {
      this.displayModal = false;
      this.$emit("close-dialog");
      this.errors = [];
    },
  },
};
</script>

<style scoped>
.display-inline-flex {
  display: inline-flex;
}
.marginBottom {
  margin-bottom: 0.3cm;
  margin-top: 1cm;
}
.p-dialog-title {
  font-size: 30px;
  color: #668fcd;
  text-align: center;
}
</style>
